import {Typography} from "@mui/material";
import Countdown from "react-countdown";
import {useState} from "react";


export const useCuentaRegresiva = ({fecha = new Date().setTime(23)}) => {
    const [faltan5, setFaltan5] = useState(false)
    const [atrazado, setAtrazado] = useState(false
    )

    const verificarTiempo = ({minutes, seconds, total}) => {
        if (total < 300000) {
            setFaltan5(true)
        }
    }

    const Reloj = ({tamano = 12, peso = 400}) => {


        const renderer = ({days, hours, minutes, seconds, completed, total}) => {

            // return <span>{`${days}d-${hours}h-${minutes}m-${seconds}s`}</span>;

            if (completed) {

                setAtrazado(true)
                return (
                    <Typography sx={{fontSize: tamano, fontWeight: peso}}>
                        {`A espera`}
                    </Typography>
                )
            } else {
                return (

                    <Typography sx={{fontSize: tamano, fontWeight: peso}}>
                        {`${hours}H-${minutes}m`}
                    </Typography>

                )
            }


        };

        return (


            <Countdown
                onTick={verificarTiempo}
                daysInHours={true}
                date={fecha}
                overtime={true}
                renderer={renderer}
            />


        )
    }

    return {
        Reloj,
        faltan5,
        atrazado
    }

}